<div class="map-wrapper">
	<div #mapContainer id="map" class="map-container"></div>
</div>
